import React from 'react';
import Flags from 'country-flag-icons/react/3x2';

export const renderCountryFlag = (isoCode, countryName) => {
  const FlagComponent = isoCode && Flags[isoCode];
  return FlagComponent && <FlagComponent title={countryName} />;
};
